import { Injectable } from '@angular/core';
import { CloseModalResponse, ModalAuthComponent } from './modal-auth.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CloseGuestModalResponse, ModalGuestAuthComponent } from './modal-guest-auth/modal-guest-auth.component';

type SaveApplicationFnType = (didCreateUser?: boolean, publicDidAuthenticate?: boolean) => void;

@Injectable({
    providedIn: 'root',
})
export class ModalAuthService {
    constructor(private _dialog: MatDialog,
        private _router: Router) {}

    MODAL_CONFIG = {
        maxWidth: '500px',
        width: '40%',
        minWidth: '340px',
        autoFocus: false,
        disableClose: true,
        data: {},
    };

    showAuthRequiredModal(autoLoginMode: boolean, saveApplicationFn?: SaveApplicationFnType) {
        const allowRegister = !autoLoginMode; // if autoLoginMode => false, else => true
        const config = {...this.MODAL_CONFIG, data: { allowRegister }}
        let dialogRef = this._dialog.open(ModalAuthComponent, config);
        dialogRef.afterClosed().subscribe((res?: CloseModalResponse) => {
            if (autoLoginMode) {
                this.autoLoginClosedCallback(res);
            } else {
                this.saveApplicationClosedCallback(res, saveApplicationFn)
            }
        });
    }

    showGuestAuthModal() {
        const config = {...this.MODAL_CONFIG }
        let dialogRef = this._dialog.open(ModalGuestAuthComponent, config);
        dialogRef.afterClosed().subscribe((res?: CloseGuestModalResponse) => {
            if (res?.success) {
                this.windowReload();
                return;
            }

            this._router.navigateByUrl('/error/400');
        });
    }

    private autoLoginClosedCallback(res?: CloseModalResponse) {
        if (!res) {
            this._router.navigateByUrl('/error/400');
        } else {
            this.windowReload();
        }
    }

    private saveApplicationClosedCallback(res?: CloseModalResponse, saveApplicationFn?: SaveApplicationFnType) {
        if (!res) {
            return;
        }

        const didCreateUser = !!res.didCreateUser;
        const publicDidAuthenticate = true;
        saveApplicationFn && saveApplicationFn(didCreateUser, publicDidAuthenticate);
    }

    windowReload() {
        window.location.reload();
    }
}
